// Route ของหน้าที่ clone มา ใช้ใน App.js:  <Routes>{siteRoutes()} ... </Routes>
// replaceExisting (ใน pages.json):
//   false = หน้า / slot / casino / sport / promotions ยังใช้ของเดิม (main.js ที่ดึงเกมจาก API)
//   true  = ใช้หน้าที่ clone มาแทนทั้งหมด
import React from 'react';
import { Route } from 'react-router-dom';
import SitePage from './SitePage';
import Articles from './Articles';
import config from './pages.json';

export const PAGES = config.pages;

export function siteRoutes() {
  const routes = PAGES
    .filter((p) => config.replaceExisting || !p.existing)
    .map((p) => (p.key === 'article'
      ? <Route key={p.key} path={p.path} element={<Articles page={p} />} />
      : <Route key={p.key} path={p.path} element={<SitePage page={p} />} />));
  // บทความเดี่ยวจากหลังบ้าน: /article/<id>
  const art = PAGES.find((p) => p.key === 'article');
  if (art) routes.push(<Route key="article-detail" path="/article/:id" element={<Articles page={art} />} />);
  return routes;
}
